<template>
  <div class="row">
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
      <!-- Détails du marchand -->
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <h4 class="position-relative text-black fw-bold mb-10">Paramétrage</h4>
            <router-link to="/liste-parametre" class="btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Retour
            </router-link>
          </div>

          <table class="table">
            <tbody>
              <tr>
                <td rowspan="3" class="align-middle">
                  <img v-if="filteredMedia.length > 0" 
                       :src="getUrlApiForFiles('Parametres', filteredMedia[0].nomMedia)" 
                       alt="Profile" 
                       class="img-thumbnail" 
                       @click="openModal(filteredMedia[0].nomMedia, 'image')" 
                       style="width: 160px; height: 160px;" />
                </td>
                <td><strong>Clé:</strong></td>
                <td>{{ parametre?.cle }}</td>
              </tr>
              <tr>
                <td><strong>Libellé:</strong></td>
                <td>{{ parametre?.libelle }}</td>
              </tr>
              <tr>
                <td><strong>Date:</strong></td>
                <td>{{format_date(parametre?.createdAt) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <!-- Autres médias -->
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div class="d-flex justify-content-center align-items-center gap-3">
            <div v-for="(media, index) in filteredAutre" :key="index" class="me-3">
              <img v-if="media.nomMedia && isImage(media.nomMedia)" 
                   :src="getUrlApiForFiles('Parametres', media.nomMedia)" 
                   alt="Autre Media" 
                   class="img-thumbnail" 
                   @click="openModal(media.nomMedia, 'image')" 
                   style="width: 120px; height: 120px;" />
              <div v-else-if="media.nomMedia && isPdf(media.nomMedia)" 
                   class="img-thumbnail"
                   @click="openModal(media.nomMedia, 'pdf')"
                   style="width: 120px; height: 120px; display: flex; justify-content: center; align-items: center;">
                <i class="fa fa-file-pdf" style="font-size: 40px; color: red;"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="create-task" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">Fichier</h6>
            <button type="button" id="close-modal" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body px-4">
            <!-- Affichage de l'image ou du PDF -->
            <div v-if="modalType === 'image'">
              <img :src="getUrlApiForFiles('Parametres', modalMedia)" alt="Image" class="img-fluid" />
            </div>
            <div v-else-if="modalType === 'pdf'">
              <embed :src="getUrlApiForFiles('Parametres', modalMedia)" type="application/pdf" width="100%" height="600px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import ApiService from "@/services/ApiService";
import { Parametre } from "@/models/Parametre";
import { error, format_date, getUrlApiForFiles } from "@/utils/utils";
import { useRoute } from "vue-router";
import { Modal } from "bootstrap";

export default defineComponent({
  name: "ViewParametre",
  setup: () => {
    const route = useRoute();
    const parametre = ref<any | null>(null);

    const modalMedia = ref<string | null>(null);
    const modalType = ref<'image' | 'pdf' | null>(null);

    function getParametre(id: string) {
      return ApiService.get("/parametres", id)
        .then(({ data }) => {
          console.log(data, 'data');
          parametre.value = data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }

    const openModal = (mediaName: string, type: 'image' | 'pdf') => {
      modalMedia.value = mediaName;
      modalType.value = type;
      
      const modalElement = document.getElementById("create-task");
      if (modalElement) {
        const modalInstance = new Modal(modalElement);
        modalInstance.show();
      }
    };

    const filteredMedia = computed(() => {
      return parametre.value?.medias.filter(media => media.typeMedia === "Photo") || [];
    });

    const filteredAutre = computed(() => {
      return parametre.value?.medias.filter(media => media.typeMedia === "Autre") || [];
    });

    const isImage = (mediaName: string) => {
      return mediaName.endsWith('.jpg') || mediaName.endsWith('.jpeg') || mediaName.endsWith('.png');
    };

    const isPdf = (mediaName: string) => {
      return mediaName.endsWith('.pdf');
    };

    onMounted(() => {
      const id = route.params.id as string;
      getParametre(id);
    });

    return { 
      parametre,
      getParametre,
      format_date,
      getUrlApiForFiles,
      filteredMedia,
      filteredAutre,
      openModal,
      isImage,
      isPdf,
      modalMedia,
      modalType
    };
  },
});
</script>
